'use client'

import { type ReactNode } from 'react'

import { ButtonFilters } from '@/components/layout/ButtonFilters'
import { Main } from '@/components/layout/Main'
import { MenuFilters } from '@/components/layout/Menu'
import { SidebarAd, SidebarClipboard, SidebarFilters } from '@/components/layout/Sidebar'
import { PageProvider } from '@/components/providers/PageProvider'
import { type PageType } from '@/defs/page'

import styles from './PageContent.module.scss'

type Props = {
  children: ReactNode
  hideSidebarAd?: boolean
  page: PageType
}

export const PageContent = ({ children, hideSidebarAd, page }: Props) => {
  const hasFilters = Object.keys(page.optionsFilters || {}).length > 0

  return (
    <PageProvider page={page}>
      <div className={styles.container}>
        {hasFilters && (
          <>
            <MenuFilters />
            <ButtonFilters />
            <SidebarFilters />
          </>
        )}
        {!hideSidebarAd && <SidebarAd />}
        <Main hasFilters={hasFilters}>{children}</Main>
        <SidebarClipboard />
      </div>
    </PageProvider>
  )
}
